import { createApp } from '@backstage/frontend-defaults';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import {
  techDocsExpandableNavigationAddonModule,
  techDocsLightBoxAddonModule,
  techDocsReportIssueAddonModule,
  techDocsTextSizeAddonModule,
} from '@backstage/plugin-techdocs-module-addons-contrib/alpha';
import { authModule } from './modules/auth';
import { catalogModule } from './modules/catalog';
import { createApiModule } from './modules/create-api';
import { giteaActionsModule } from './modules/gitea-actions';
import { navModule } from './modules/nav';
import { pm2Module } from './modules/pm2';
import { scaffolderModule } from './modules/scaffolder';
import { techdocsModule } from './modules/techdocs';

export default createApp({
  features: [
    apiDocsPlugin,
    catalogPlugin,
    authModule,
    catalogModule,
    createApiModule,
    giteaActionsModule,
    notificationsPlugin,
    techDocsExpandableNavigationAddonModule,
    techDocsLightBoxAddonModule,
    techDocsReportIssueAddonModule,
    techDocsTextSizeAddonModule,
    navModule,
    pm2Module,
    scaffolderModule,
    techdocsModule,
  ],
});
